export const patientProfileSections = [
  {
    id: 'identity',
    title: 'Datos personales e identificacion',
    fields: ['name', 'documentId', 'clinicalHistoryNumber', 'birthDate', 'age', 'sex'],
  },
  {
    id: 'contact',
    title: 'Contacto y direccion',
    fields: ['phone', 'email', 'address', 'city', 'province'],
  },
  {
    id: 'clinical',
    title: 'Antecedentes y medicacion',
    fields: ['medicalHistory', 'familyHistory', 'allergies', 'currentMedications'],
  },
  {
    id: 'priority',
    title: 'Condicion prioritaria',
    fields: ['disability', 'disabilityDetail', 'priorityGroup'],
  },
  {
    id: 'emergency',
    title: 'Contacto de emergencia',
    fields: ['emergencyContact', 'emergencyRelationship', 'emergencyPhone'],
  },
];

export const priorityGroupOptions = [
  'Ninguno',
  'Nino, nina o adolescente',
  'Adulto mayor',
  'Embarazo',
  'Discapacidad',
  'Enfermedad catastrofica',
  'Victima de violencia',
  'Movilidad humana',
];

export const sexOptions = ['Femenino', 'Masculino', 'Intersexo', 'No especifica'];

export const calculatePatientAge = (birthDate) => {
  if (!birthDate) return '';
  const birth = new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return '';
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const monthDiff = now.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age >= 0 ? String(age) : '';
};

export const normalizePatientProfile = (patient = {}) => {
  const allergies = patient.allergies || (
    patient.medicalHistory?.toLowerCase().includes('alergia') ? patient.medicalHistory : ''
  );

  return {
    id: patient.id || '',
    username: patient.username || '',
    role: patient.role || 'patient',
    name: patient.name || '',
    documentType: patient.documentType || 'Cedula',
    documentId: patient.documentId || '',
    clinicalHistoryNumber: patient.clinicalHistoryNumber || patient.id || '',
    fileNumber: patient.fileNumber || '',
    birthDate: patient.birthDate || '',
    age: calculatePatientAge(patient.birthDate),
    sex: patient.sex || '',
    email: patient.email || '',
    phone: patient.phone || '',
    address: patient.address || '',
    city: patient.city || '',
    province: patient.province || '',
    insurance: patient.insurance || patient.plan || '',
    plan: patient.plan || patient.insurance || '',
    serviceActive: patient.serviceActive ?? true,
    medicalHistory: patient.medicalHistory || '',
    familyHistory: patient.familyHistory || '',
    allergies,
    currentMedications: patient.currentMedications || '',
    disability: patient.disability || 'No',
    disabilityDetail: patient.disabilityDetail || '',
    priorityGroup: patient.priorityGroup || 'Ninguno',
    emergencyContact: patient.emergencyContact || '',
    emergencyRelationship: patient.emergencyRelationship || '',
    emergencyPhone: patient.emergencyPhone || '',
    weight: patient.weight || '',
    height: patient.height || '',
    bloodPressure: patient.bloodPressure || '',
    temperature: patient.temperature || '',
    pulse: patient.pulse || '',
    respiratoryRate: patient.respiratoryRate || '',
    pulseOximetry: patient.pulseOximetry || '',
    capillaryGlucose: patient.capillaryGlucose || '',
  };
};

export const validatePatientProfile = (profile) => {
  const errors = [];
  if (!profile.name?.trim()) errors.push('Nombre completo requerido.');
  if (!profile.documentId?.trim()) errors.push('Documento de identificacion requerido.');
  if (!profile.birthDate) errors.push('Fecha de nacimiento requerida.');
  if (!profile.sex?.trim()) errors.push('Sexo requerido.');
  if (!profile.phone?.trim()) errors.push('Telefono requerido.');
  if (!profile.address?.trim()) errors.push('Direccion requerida.');
  if (!profile.emergencyContact?.trim()) errors.push('Contacto de emergencia requerido.');
  if (!profile.emergencyPhone?.trim()) errors.push('Telefono de emergencia requerido.');
  return errors;
};

export const getPatientProfileCompletion = (profile) => {
  const required = ['name', 'documentId', 'birthDate', 'sex', 'phone', 'address', 'emergencyContact', 'emergencyPhone'];
  const completed = required.filter((field) => String(profile[field] || '').trim()).length;
  return {
    completed,
    total: required.length,
    percentage: Math.round((completed / required.length) * 100),
  };
};
